import gql from 'graphql-tag';
import FieldsCreditQrCode from 'graphql/fields/FieldsCreditQrCode';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String',
	'name': 'String!',
	'credits_amount': 'Int!',
	'price': 'Float!',
	'timeslot_kind_guid': 'String',
	'status': 'String',
};

export default gql(`
	mutation credit_qr_code( ${ HelperGraphql.createFields( fields ) } ) {
	    credit_qr_code( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsCreditQrCode}
	    }
	}
`);

